module.exports = {"TXTWCL_Singles":{"id":"TXTWCL_Singles","defaultMessage":"Singole","track":"Singles","ontario":"Scommesse singole"}}